<template>

  <div class="text-center mt-10 mb-16">

    <transition name="slide-fade">
      <div :id="htmlId" :aria-hidden="!open" v-show="open" class="mb-8">
        <slot name="content"></slot>
      </div>
    </transition>
    
    <button 
      class="btn mx-auto text-xl" 
      @click="togglePanel" 
      :aria-expanded="open" 
      :aria-controls="htmlId"
    >
      {{ buttonText }}
      <svg-icon :name="iconName" classes="w-3 h-3 ml-2 flex-shrink-0"></svg-icon>
    </button>

  </div>

</template>

<script>

import UuidGenerator from '@/lib/uuid.js'

export default {
  mixins: [UuidGenerator],

  props: {
    expanded: {
      default: false
    }
  },

  data() {
    return {
      open: this.expanded,
    }
  },

  computed: {
    htmlId() {
      return `collapsible-${this.uuid}`;
    },
    iconName() {
      return this.open ? 'caret-up' : 'caret-down';
    },
    buttonText() {
      return this.open ? 'Hide' : 'Load More';
    }
  },

  methods: {
    togglePanel() {
      this.open = !this.open;

      this.$parent.$emit("accordion-panel-toggled", { 
        htmlId: this.htmlId,
        open: this.open 
      });
    },

    closePanel() {
      this.open = false;
    },

    openPanel() {
      this.open = true;
    }
  }
}
</script>
